import { IconButton } from '@michelin/acid-components';
import React from 'react';
import { useRefreshButtonStyles } from './useRefreshButtonStyles';
import Refresh from '@material-ui/icons/Refresh';
;
export const RefreshButton = (props) => {
    const { onClick, } = props;
    const classes = useRefreshButtonStyles(props);
    return (React.createElement(IconButton, { size: "medium", onClick: onClick },
        React.createElement(Refresh, null)));
};
//# sourceMappingURL=RefreshButton.js.map